import React from "react";
import cn from "classnames";
import styles from "./About.module.sass";
// import Image from "../../../components/Image";
import ScrollParallax from "../../../components/ScrollParallax";


const items = [
  {
    title: "Create limitless, custom deals for free",
    content:
      "No one knows your restaurant like you do, so we give you the control to offer any kind of deals you want, whenever you want.",
    color: "#9757D7",
  },
  {
    title: "We never invoice you.",
    content:
      "Payments are one direction — we only pay you! How's that for a change?",
    color: "#45B26B",
  },
];

const About = () => {
  return (
    <div className={cn("section", styles.book)}>
      <div className={cn("container", styles.container)}>
 
        <div className={styles.row}>
          <div className={styles.col}>
                      <div className={cn("stage", styles.stage)}>Reffo Deals</div>
           
            <h2 className={cn("h2", styles.title)}>
              Simple, effective. <br/> Easy peasy!
            </h2>
            <div className={styles.info}>
              Reffo was built with restaurants in mind. We know how valuable your time is, so 
              we stay out of your way.
              <br/><br/><br/>
            </div>
            <div className={styles.list}>
              {items.map((x, index) => (
                <ScrollParallax className={styles.item} key={index}>
                  <div
                    className={styles.number}
                    style={{ backgroundColor: x.color }}
                  >
                    0{index + 1}
                  </div>
                  <div className={styles.subtitle}>{x.title}</div>
                  <div className={styles.content}>{x.content}</div>
                </ScrollParallax>
              ))}
            </div>
          </div>
          <div className={styles.col}>
            <div className={styles.bg}>
              <img
                srcSet="/images/content/womanChefCooking.png 2x"
                src="/images/content/womanChefCooking.png"
                alt="About pic"
              />
              {/* <div>
                <ScrollParallax className={styles.preview} animateIn="fadeInUp">
                  <Image
                    srcSet="/images/content/stickers/layer 23.png 2x"
                    srcSetDark="/images/content/stickers/layer 23.png 2x"
                    src="/images/content/stickers/layer 23.png"
                    srcDark="/images/content/stickers/layer 23.png"
                    alt="Rocket"
                  />
                </ScrollParallax>
                <ScrollParallax className={styles.preview} animateIn="fadeInUp">
                  <img
                    srcSet="/images/content/stickers/layer 25.png 2x"
                    src="/images/content/stickers/layer 25.png"
                    alt="Ball"
                  />
                </ScrollParallax>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
